import { Input } from "@/components/ui/input";
import { formatReg, normalizeReg } from "@/lib/india";

/**
 * Registration plate input.
 * - Stores the NORMALIZED value (KA01AB1234) via onChange(normalized).
 * - Displays a formatted version (KA 01 AB 1234) while typing.
 */
export function RegistrationInput({ value, onChange, disabled, testid, placeholder }) {
    const display = formatReg(value);
    return (
        <Input
            value={display}
            onChange={(e) => onChange(normalizeReg(e.target.value))}
            disabled={disabled}
            className="font-mono uppercase tracking-wider plate"
            placeholder={placeholder || "KA 01 AB 1234"}
            data-testid={testid || "reg-input"}
            maxLength={20}
            autoComplete="off"
            spellCheck="false"
        />
    );
}
